// components/Map/MeterMarker.jsx

import "./MeterMarker.styles.scss";

import React, { useEffect, useRef, useState } from "react";
import { Marker, Popup } from "react-map-gl";

import Meter from "../Meter/Meter";

/**
 * A Meter Map Marker Component
 * @param {Object} location
 * @param {string | number}index
 * @param {string} focusedLocation - the id of the focused location
 * @param {string} selectedLocation - the id of the selected location
 * @param {CallableFunction} onMarkerClick
 * @return {JSX.Element}
 * @constructor
 */
const MeterMarker = ({ location, index, focusedLocation, selectedLocation, onMarkerClick }) => {
	// MARKER
	const markerRef = useRef();

	/** Build the class list for the marker */
	const getMarkerClasses = () => {
		const classes = ["meter-marker"];

		// Active Location
		if (selectedLocation === location._id) {
			classes.push("selected");
		}

		// Emphasize/Understate class for focused Marker
		if (focusedLocation !== null) {
			if (location._id === focusedLocation) {
				classes.push("emphasize");
			} else {
				classes.push("understate");
			}
		}

		return classes.toString().replace(/,/g, " ");
	};

	// POPUP
	const popupRef = useRef();
	const [popupOpen, setPopupOpen] = useState(false);

	const handleClickOutside = (event) => {
		if (popupRef.current && !popupRef.current.contains(event.target)) {
			setPopupOpen(false);
			onMarkerClick && onMarkerClick(null);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, []);

	return (
		<>
			{popupOpen && (
				<>
					<Popup
						className={"meter-marker-popup"}
						latitude={location.lat}
						longitude={location.lng}
						offset={{ top: [0, 18], bottom: [0, -18] }}
						maxWidth={"max-content"}
						onClose={() => setPopupOpen(false)}
					>
						<div ref={popupRef} className='popup-head'>
							<h6>
								{index}. {location.name}
							</h6>
						</div>
					</Popup>
				</>
			)}

			<Marker
				latitude={location.lat}
				longitude={location.lng}
				anchor='center'
				onClick={(e) => {
					e.originalEvent.stopPropagation();
					setPopupOpen(!popupOpen);
					onMarkerClick && onMarkerClick(location._id);
				}}
			>
				<div ref={markerRef} className={getMarkerClasses()}>
					<Meter value={Math.round(location.totalMarketScore) || 0} size={48} stroke={4} />
				</div>
			</Marker>
		</>
	);
};

export default MeterMarker;
